// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"fec36f0f","395":"dfb2f894","520":"77342dc0","542":"a42a66e9","788":"2828625f","794":"46504e50"}[chunkId] + ".css";
};